export default "__VITE_ASSET__587a842d__"